import { SyntheticEvent } from 'react'
import ClassNameBuilder from '../../../tools/ClassNameBuilder'

interface PrimeIconProps {
    name: PrimeIconName
    size?: number
    spin?: boolean
    className?: string
    onClick?: (event: SyntheticEvent) => void
}

export default function PrimeIcon({ name, size, spin, className, onClick }: PrimeIconProps) {
    // prettier-ignore
    const classNames = new ClassNameBuilder() // Do not collapse.
        .add(pi(name))
        .add(className)
        .addIf('pi-spin', spin)
    return <i className={classNames.toString()} style={{ fontSize: size }} onClick={onClick} />
}

export const pi = (name: PrimeIconName) => `pi pi-${name}`
